import React, { useState, useEffect } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import Utils from "../../../Common/Utils";
import AppSettings from "../../../Settings/AppSettings";
import Paginator from "../../Common/Paginator";
import DatePicker from "react-datepicker";
import CustomDatePicker from "../../Common/CustomDatePicker";
import "react-datepicker/dist/react-datepicker.css";
import AuthManager from "../../../Common/AuthManager";

function VersionManagementList(props) {
  var stDate = new Date();
  stDate.setDate(stDate.getDate() - 6);
  var edDate = new Date();
  var [partyList, setpartyList] = React.useState([]);
  var [selectedPartyId, setSelectedPartyId] = React.useState("-1");
  var [loadError, setLoadError] = React.useState(false);
  var [vquerySetList, setvquerySetList] = React.useState([]);
  var [selectedQuerySet, setselectedQuerySet] = React.useState(null);
  var [vqueryList, setvqueryList] = React.useState([]);
  var [vqueryListCopy, setvqueryListCopy] = React.useState([]);
  var [loading, setLoading] = React.useState(false);
  var [recordPerPage, setRecordPerPage] = useState(5);
  var [searchval, setSearchVal] = useState("");
  var [pageRangeArray, setPageRangeArray] = useState([5, 10, 15, 25, 50, 100]);
  var [startDate, setStartDate] = useState(stDate);
  var [endDate, setEndDate] = useState(edDate);
  const startDateref = React.createRef();
  const endDateref = React.createRef();

  const pageRange = 10;

  const searchValRef = React.useRef(searchval);
  searchValRef.current = searchval;

  function getDate_as_string(dt) {
    return (
      dt.getFullYear() +
      "-" +
      Utils.appendLeadingZeroes(dt.getMonth() + 1) +
      "-" +
      Utils.appendLeadingZeroes(dt.getDate())
    );
  }

  async function load_query_List(setid) {
    setpartyList([]);
    setLoading(true);
    const api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const ret = await ServiceWrapper.doPost(
      api_base_url + "versionmanagement/query/list",
      {
        startdate: getDate_as_string(startDate),
        enddate: getDate_as_string(endDate),
        setid: setid,
      },
      null,
      AuthManager.getGmsToken()
    );
    setLoadError(ret.errorfound);
    if (!ret.errorfound) {
      setvqueryList(ret.data.data);
      const tempVar = JSON.parse(JSON.stringify(ret.data.data));
      setvqueryListCopy(tempVar);
      get_party_list(tempVar);
    }
    setLoading(false);
  }

  async function load_query_set_list() {
    setLoading(true);
    const api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const ret = await ServiceWrapper.doGet(
      api_base_url + "versionmanagement/queryset/list",
      null,
      null,
      AuthManager.getGmsToken()
    );
    setLoadError(ret.errorfound);
    if (!ret.errorfound) {
      setvquerySetList(ret.data.data);
      let tempVar = JSON.parse(JSON.stringify(ret.data.data));
      if (ret.data.data.length > 0) {
        setselectedQuerySet((n) => tempVar[0].uid);
        load_query_List(tempVar[0].uid);
      }
    }
    setLoading(false);
  }

  function get_party_list(qdata) {
    var plist = [];
    qdata.forEach((item) => {
      var nitem = { partyid: item.partyid, partyname: item.partyname };
      if (!plist.map((a) => a.partyid).includes(item.partyid)) {
        plist.push(nitem);
      }
    });
    setpartyList(plist);
    setSelectedPartyId("-1");
  }

  async function handle_page_change(pagenumber, paged_data) {
    if (paged_data !== undefined) {
      var tt = paged_data;
      setvqueryList(tt);
    }
    await Utils.sleep(100);
  }

  async function handle_log_search(val) {
    if (vqueryList.length === 0)
      setvqueryList((t) => (t = get_filtered_records()));
    val = val.toString().trim().toLowerCase();
    setSearchVal((n) => (n = val));
    await Utils.sleep(100);
  }

  function handle_Party_change(newval) {
    setSelectedPartyId(newval);
  }

  function handle_recordsperpage_change(newval) {
    setRecordPerPage(parseInt(newval));
  }

  function get_filtered_records() {
    let filteredData = JSON.parse(JSON.stringify(vqueryListCopy));
    if (!Utils.isEmpty(searchValRef.current)) {
      filteredData = vqueryListCopy.filter((item) => {
        if (
          (item.username != null &&
            item.username.toLowerCase().includes(searchValRef.current)) ||
          (item.description != null &&
            item.description.toLowerCase().includes(searchValRef.current)) ||
          (item.query != null &&
            item.query.toLowerCase().includes(searchValRef.current)) ||
          (item.createdAt != null &&
            item.createdAt.toLowerCase().includes(searchValRef.current))
        ) {
          return true;
        } else {
          return false;
        }
      });
    }
    return filteredData;
  }

  useEffect(() => {
    load_query_set_list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {loading && (
        <div>
          <div className="p-2 bg-white alert alert-primary small" role="alert">
            <span className="fas fa-circle-notch fa-spin" />
            &nbsp;
            <strong>Loading Queries</strong>
          </div>
        </div>
      )}

      {!loading && (
        <React.Fragment>
          <div>
            <div className="d-flex flex-nowrap">
              <div className="">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="yyyy-MM-dd"
                  customInput={<CustomDatePicker ref={startDateref} />}
                />
              </div>
              <div className="">
                &nbsp;
                <DatePicker
                  className="col-auto"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                  customInput={<CustomDatePicker ref={endDateref} />}
                />
              </div>

              <div className="">
                &nbsp;
                <select
                  id="qsetDrp"
                  className="border form-control-sm border-secondary"
                  value={selectedQuerySet || ""}
                  onChange={(e) => {
                    setselectedQuerySet(e.target.value);
                  }}
                >
                  {vquerySetList.map((item) => (
                    <option key={item.uid} value={item.uid}>
                      {item.name}
                      {Utils.isUndefinedOrNull(item.end_date) && " (current)"}
                    </option>
                  ))}
                </select>
                &nbsp;
                <button
                  className="col-auto"
                  type="button"
                  onClick={() => load_query_List(selectedQuerySet)}
                >
                  <span className="fa fa-search"></span>&nbsp; Search
                </button>
              </div>
            </div>
          </div>
          <div className="row">&nbsp;</div>
          {vqueryListCopy.length > 0 && !loadError && (
            <React.Fragment>
              <div>
                <h1 className="h6 float-start">
                  Queries from <i>{getDate_as_string(startDate)}</i> to{" "}
                  <i>{getDate_as_string(endDate)}</i>
                </h1>
                <div className="float-end">
                  <select
                    id="partyDrp"
                    className="border form-control-sm border-secondary"
                    value={selectedPartyId}
                    onChange={(e) => {
                      handle_Party_change(e.target.value);
                    }}
                  >
                    <option value={"-1"}>All</option>
                    {partyList.map((item) => (
                      <option key={item.partyid} value={item.partyid}>
                        {item.partyname}
                      </option>
                    ))}
                  </select>{" "}
                  &nbsp;
                  <select
                    id="inputState"
                    className="border form-control-sm border-secondary float-end"
                    value={recordPerPage}
                    onChange={(e) => {
                      handle_recordsperpage_change(e.target.value);
                    }}
                  >
                    {pageRangeArray.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </React.Fragment>
          )}

          {vqueryListCopy.length > 0 && !loadError && (
            <div>
              <input
                type="text"
                className="border form-control form-control-sm border-secondary float-end"
                placeholder="Search queries"
                onChange={(e) => handle_log_search(e.target.value)}
              />
            </div>
          )}
          <div className="row">&nbsp;</div>
          <div className="row">&nbsp;</div>
          <div className="table-responsive">
            {vqueryList.length > 0 && !loadError && (
              <React.Fragment>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th width="10%">User</th>
                      <th width="50%">Module / Query</th>
                      <th width="10%">On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vqueryList.map((item, index) => (
                      <tr key={"vquery" + index}>
                        <td>{item.username}</td>
                        <td>
                          <span className="badge bg-primary">
                            {item.description}
                          </span>
                          <br />
                          {item.query}
                        </td>
                        <td>
                          {item.createdAt.split("T")[0]}
                          <br />
                          <small className="text-muted">
                            <strong>{item.createdAt.split("T")[1]}</strong>
                          </small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </React.Fragment>
            )}
            <div className="float-end">
              <Paginator
                recordPerPage={recordPerPage}
                totalRecords={get_filtered_records().length}
                data={get_filtered_records()}
                pageRange={pageRange}
                onPageChange={handle_page_change}
                simple={true}
              />
            </div>
            {vqueryList.length === 0 &&
              vqueryListCopy.length > 0 &&
              !loadError && (
                <div className="bg-white alert alert-danger" role="alert">
                  <strong>Sorry!</strong>, No records found during our search
                </div>
              )}
            {vqueryListCopy.length === 0 && !loadError && (
              <div className="bg-white alert alert-danger" role="alert">
                <strong>Sorry!</strong>, No records found for the selected date
                range
              </div>
            )}
            {loadError && (
              <div className="bg-white alert alert-danger" role="alert">
                <strong>Oops</strong>, An error occurred
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default VersionManagementList;
